/**
 * Chrome-less full-viewport layout — used for routes whose content
 * needs the entire screen. Examples:
 *
 *   - /replay/:id   — the Three.js viewer is the page
 *   - /live/:id     — same, with live SSE
 *   - /overlay      — OBS Browser Source mount
 *
 * Removes the document-level body chrome by setting `position: fixed`
 * + `inset: 0` so the route content fills the viewport regardless of
 * the document scroll position.
 */
import { Outlet } from "react-router-dom";

export function FullScreenLayout() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "#050505",
        color: "#e8e8e8",
        overflow: "hidden",
      }}
    >
      <Outlet />
    </div>
  );
}
